//import Store from "@/store";
//import { ViewController, StatementController, LinkController, ModelUserController, RatingController } from "@/controller/index.js";
import { WorkbreakController, PresenceController, TimeEntryController, ProjectController } from "./"
import { NfcChipRepository } from "../repository"
import { ObjectStorage } from '@/model'
import { DateTimeUtils } from "@/utils/"
import type { NetworkStatusInterface, LocalSystemStatusInterface } from "@/interface"

const UpdateController = {
    nfcChipId: '',
    nfcUpdateInterval: 500,
    nfcUpdateTimeout: -1,
    updateInterval: 15000,
    updateTimeout: -1,
    networkUpdateInterval: 5000,
    networkUpdateTimeout: -1,
    networkUpdateStopped: false,
    networkUpdateInProgress: false,

    employees: [] as Array<number>,
    updateTimeEntries: false,
    activeDay: 0,
    isWorkstation: false,

    nfcUpdateInProgress: false,
    updateInProgress: false,
    lastNfcUpdateFetched: 0,
    lastUpdateFetched: 0,
    lastProjectUpdateFetched: 0,
    nfcUpdateStopped: false,
    updateStopped: false,
    route: {} as any,
    nfcResponse: null as any,
    serverResponse: '',
    networkStatus: null as NetworkStatusInterface |null,

        //callbacks
    beforeCheckNfcUpdate() { /* set this */ },
    beforeCheckUpdate() { /* set this */ },
    onNfcUpdate(nfcChipId: string) { /* quick and dirty */ },
    onUpdate(workbreaks: ObjectStorage, presences: ObjectStorage, timeentries: ObjectStorage | null, projects: ObjectStorage | null ) { /* quick and dirty */ },
    onNetworkUpdate(networkStatus: NetworkStatusInterface | null) { /*set this */ },
    afterCheckNfcUpdate() { /* for workaround ts compiler */ },
    afterCheckUpdate() { /* for workaround ts compiler */ },

    getNfcUpdateInProgress() {
        return this.nfcUpdateInProgress;
    },

    setNfcUpdateInProgress(nfcUpdateInProgress: boolean) {
        this.nfcUpdateInProgress = nfcUpdateInProgress;
    },

    getUpdateInProgress() {
        return this.updateInProgress;
    },

    setUpdateInProgress(updateInProgress: boolean) {
        this.updateInProgress = updateInProgress;
    },

    getLastNfcUpdateFetched() {
        return this.lastNfcUpdateFetched;
    },

    setLastNfcUpdateFetched(updateFetched: number) {
        this.lastNfcUpdateFetched = updateFetched;
    },

    getLastUpdateFetched() {
        return this.lastUpdateFetched;
    },

    setLastUpdateFetched(updateFetched: number) {
        this.lastUpdateFetched = updateFetched;
    },

    getRoute() {
        return this.route;
    },

    setRoute(route:any) {
        this.route = route;
        //console.log("UpdateController:setRoute:route", this.route);
    },

    getBeforeCheckNfcUpdate() {
        return this.beforeCheckNfcUpdate;
    },

    setBeforeCheckNfcUpdate(beforeCheckNfcUpdate: any) {
        this.beforeCheckNfcUpdate = beforeCheckNfcUpdate;
    },

    getBeforeCheckUpdate() {
        return this.beforeCheckUpdate;
    },

    setBeforeCheckUpdate(beforeCheckUpdate: any) {
        this.beforeCheckUpdate = beforeCheckUpdate;
    },

    getOnNfcUpdate() {
        return this.onNfcUpdate;
    },

    setOnNfcUpdate(onNfcUpdate: any) {
        this.onNfcUpdate = onNfcUpdate;
    },

    getOnUpdate() {
        return this.onUpdate;
    },

    setOnUpdate(onUpdate: any) {
        this.onUpdate = onUpdate;
    },

    getOnNetworkUpdate() {
        return this.onNetworkUpdate;
    },

    setOnNetworkUpdate(onNetworkUpdate: any) {
        this.onNetworkUpdate = onNetworkUpdate;
    },

    getAfterCheckNfcUpdate() {
        return this.afterCheckNfcUpdate;
    },

    setAfterCheckNfcUpdate(afterCheckNfcUpdate: any) {
        this.afterCheckNfcUpdate = afterCheckNfcUpdate;
    },    

    getAfterCheckpdate() {
        return this.afterCheckUpdate;
    },

    setAfterCheckUpdate(afterCheckUpdate: any) {
        this.afterCheckUpdate = afterCheckUpdate;
    },

    getUpdateTimeEntries() {
        return this.updateTimeEntries;
    },

    setUpdateTimeEntries(updateTimeEntries: boolean) {
        this.updateTimeEntries = updateTimeEntries;
    },      

    getActiveDay() {
        return this.activeDay;
    },

    setActiveDay(activeDay: number) {
        this.activeDay = activeDay
    }, 

    getServerResponse() {
        return this.serverResponse;
    },

    nfcUpdate() {
        window.clearTimeout(UpdateController.nfcUpdateTimeout);
        UpdateController.nfcUpdateTimeout = window.setTimeout(() => {
            if (!UpdateController.getNfcUpdateInProgress()) UpdateController.checkNfcUpdate();
            if (!this.nfcUpdateStopped) UpdateController.nfcUpdate();
        }, UpdateController.nfcUpdateInterval);
    },

    async update() {
        window.clearTimeout(UpdateController.updateTimeout);
        UpdateController.updateTimeout = window.setTimeout(async() => {  
            try {
                await UpdateController.checkUpdate();
                this.serverResponse = 'Ok';
            } catch (err) {
                console.error('checkUpdate failed: ', err);
                this.serverResponse = 'Error ' + err.message;
            } finally {
                if (!this.updateStopped) UpdateController.update();
            }
        }, UpdateController.updateInterval);
    },

    startNfcUpdate() {
        this.nfcUpdateStopped = false;
        this.nfcUpdate();
    },

    startUpdate() {
        this.updateStopped = false;
        this.update();
    },

    stopNfcUpdate() {
        this.nfcUpdateStopped = true;
        window.clearTimeout(UpdateController.nfcUpdateTimeout);
    },

    stopUpdate() {
        this.updateStopped = true;
        window.clearTimeout(UpdateController.updateTimeout);
    },

    async checkNfcUpdate() {
        //console.log("UpdateController:this.route", this.route);
        if (this.route.fullPath.indexOf('/workspace') != -1) await this.fetchNfcChipUpdate();
    },

    async checkUpdate() {
        //console.log("UpdateController:udpate this.route", this.route);
        if (this.route.fullPath.indexOf('/overview') != -1 || this.route.fullPath.indexOf('/workspace') != -1) await this.fetchEmployeeUpdate();
    },

    async fetchNfcChipUpdate() {
        if (UpdateController.getNfcUpdateInProgress()) {
            return;
        }

        if (this.beforeCheckNfcUpdate && typeof(this.beforeCheckNfcUpdate) != 'undefined' && typeof this.beforeCheckNfcUpdate === "function") {
            this.beforeCheckNfcUpdate();
        }

        UpdateController.setNfcUpdateInProgress(true)

        //console.log('UpdateController::fetchNfcChipUpdate', Date.now(), this.nfcChipId)
        const id = await NfcChipRepository.getUpdate()
        this.nfcResponse = NfcChipRepository.response

        //console.log('fetchNfcChipUpdate', id)
        //if (this.nfcChipId) this.onNfcUpdate(this.nfcChipId)
        this.nfcChipId = id
        if (this.nfcChipId && this.route.fullPath.indexOf('setchip') == -1) this.stopNfcUpdate()
        this.onNfcUpdate(id)
        this.nfcChipId = ''

        UpdateController.setNfcUpdateInProgress(false);

        if (this.afterCheckNfcUpdate && typeof this.afterCheckNfcUpdate === "function") {
            this.afterCheckNfcUpdate();
        }

    },

    async fetchEmployeeUpdate() {
        if (UpdateController.getUpdateInProgress()) {
            return;
        }

        if (this.beforeCheckUpdate && typeof(this.beforeCheckUpdate) != 'undefined' && typeof this.beforeCheckUpdate === "function") {
            this.beforeCheckUpdate();
        }

        UpdateController.setUpdateInProgress(true)
            //TODO update employees, but this only makes sense if we have the updated timestamp set

        //console.log('UpdateController::fetchEmployeeUpdate', this.employees)
        /* const workbreaks = await WorkbreakController.getActiveWorkbreak(this.employees)
        const presences = await PresenceController.getActivePresence(this.employees)
        let timeentries = null
        if (this.updateTimeEntries) {
            timeentries = await TimeEntryController.fetchDayTimeEntries(this.employees, this.activeDay)
        }

        //console.log('UpdateController::workbreaks', workbreaks, presences)
        this.onUpdate(workbreaks, presences, timeentries)

        UpdateController.setUpdateInProgress(false);

        if (this.afterCheckUpdate && typeof this.afterCheckUpdate === "function") {
            this.afterCheckUpdate();
        } */
        if (this.isWorkstation) this.activeDay = DateTimeUtils.getUnixTimestamp()
            //console.log('UpdateController before Upate', this.isWorkstation, this.activeDay)
        try {   
            let fetchProjectUpdates = false;
            const now = DateTimeUtils.getUnixTimestamp();
            if (now > this.lastProjectUpdateFetched +60) {
                fetchProjectUpdates = true
                this.lastProjectUpdateFetched = now
            }
            // parallel statt seriell (schneller + weniger Tick-Drift)
            const [workbreaks, presences, timeentries, projects] = await Promise.all([
                WorkbreakController.getActiveWorkbreak(this.employees),
                PresenceController.getActivePresence(this.employees),
                this.updateTimeEntries ? TimeEntryController.fetchDayTimeEntries(this.employees, this.activeDay) : Promise.resolve(null),
                fetchProjectUpdates ? ProjectController.fetchProjects() : Promise.resolve(null)
            ]);
            
            this.onUpdate(workbreaks, presences, timeentries, projects);
        } catch (err) {
                // wichtig: Fehler NICHT “still” killen lassen
            console.error("fetchEmployeeUpdate failed:", err);
                // optional: hier könntest du z.B. einen offline-state setzen
        } finally {
            UpdateController.setUpdateInProgress(false);

            if (this.afterCheckUpdate && typeof this.afterCheckUpdate === "function") {
                this.afterCheckUpdate();
            } 
        }       

    },

    getNetworkStatus() {
        return this.networkStatus
    },

    getNetworkAvailable() {
        return (
            this.networkStatus?.wifiConnected === true &&
            this.networkStatus?.gatewayReachable === true
        )
    },    

    networkUpdate() {
        window.clearTimeout(UpdateController.networkUpdateTimeout)

        UpdateController.networkUpdateTimeout = window.setTimeout(async () => {
            if (!UpdateController.networkUpdateInProgress) {
                await UpdateController.fetchNetworkStatus()
            }

            this.onNetworkUpdate(this.networkStatus)

            if (!UpdateController.networkUpdateStopped) {
                UpdateController.networkUpdate()
            }
        }, UpdateController.networkUpdateInterval)
    },    

    startNetworkUpdate() {
        this.networkUpdateStopped = false
        this.fetchNetworkStatus()
        this.networkUpdate()
    },

    stopNetworkUpdate() {
        this.networkUpdateStopped = true
        window.clearTimeout(UpdateController.networkUpdateTimeout)
    },   
    
    async fetchNetworkStatus() {
        if (this.networkUpdateInProgress) {
            return
        }

        this.networkUpdateInProgress = true

        try {
            const response = await fetch('http://127.0.0.1:9999/status', {
                method: 'GET',
                cache: 'no-store'
            })

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`)
            }

            const status = await response.json() as LocalSystemStatusInterface

            this.networkStatus = status.network

        } catch (err) {
            console.error('fetchNetworkStatus failed:', err)

            /*
            * Wichtig:
            *
            * Wenn localhost:9999 selbst nicht erreichbar ist, wissen wir
            * NICHT, ob WLAN ausgefallen ist.
            *
            * Deshalb nicht wifiConnected=false setzen.
            */
            this.networkStatus = null
        } finally {
            this.networkUpdateInProgress = false
        }
    },    
}

//UpdateController.startUpdate();

export default UpdateController;
